import { TEMPLATE_DATA } from "./conststns"

export const getBlockQuestion = (type, question) => {
    return TEMPLATE_DATA(type, question)
}